import { Player } from './MediaPlayer/Player/Player';

interface IProps {}

export const Transcription = (props: IProps) => {
  return <Player />;
};
